import filterMoviesByWeekAndCinemas from "./filterMoviesByWeekAndCinemas"


const filterMoviesByWeekAndCinema = (order, items, performances, weekObj, cinemaId = false, dateSettings) => {
    const cinemaIds = cinemaId ? [cinemaId] : false
   return filterMoviesByWeekAndCinemas(order, items, performances, weekObj, cinemaIds, dateSettings)
}

export default filterMoviesByWeekAndCinema